var map = {
	"./factory-daili.svg": "2343",
	"./factory-dan.svg": "82e6",
	"./factory-finance.svg": "972c",
	"./factory-gc.svg": "cf6e",
	"./factory-gonggao.svg": "e88e",
	"./factory-goods.svg": "5dca",
	"./factory-jg.svg": "0bdf",
	"./factory-ka.svg": "fea7",
	"./factory-zha.svg": "6b05",
	"./factory-zhiban.svg": "3765",
	"./opera-b.svg": "f7ff",
	"./opera-da.svg": "e4a3",
	"./opera-fac.svg": "12d9",
	"./opera-facle.svg": "18f4",
	"./opera-gere.svg": "24c7",
	"./opera-goc.svg": "e6ee",
	"./opera-gonc.svg": "17f8",
	"./opera-mk.svg": "70de",
	"./opera-mol.svg": "a6a8",
	"./opera-ne.svg": "f543",
	"./opera-pi.svg": "f518",
	"./opera-pr.svg": "f41b",
	"./opera-roe.svg": "05bb",
	"./opera-set.svg": "2928",
	"./opera-user.svg": "86fc",
	"./opera-wd.svg": "e5fc",
	"./opera-xiey.svg": "51ca",
	"./opera-xit.svg": "cd68",
	"./opera-zidian.svg": "8269"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08f3";